import { Box, VStack } from '@genial/components';
import React from 'react';
import { FlatList } from 'react-native';

import { FixedFeeTermHistoryItem } from '../../../../../store/fixedFee/types';

import { TimelineItemLoading, TimelineItemMemo } from './components/TimelineItem';

interface StatusTimelineProps {
  items: FixedFeeTermHistoryItem[];
}

export const ItemSeparator: React.FC = () => {
  return <Box height="stack.xxs" />;
};

export const StatusTimeline: React.FC<StatusTimelineProps> = ({ items }) => {
  return (
    <VStack>
      <FlatList
        data={items}
        keyExtractor={(item) => item.id}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={({ item, index }) => <TimelineItemMemo {...item} isDimmed={index > 0} />}
        showsVerticalScrollIndicator={false}
      />
    </VStack>
  );
};

interface StatusTimelineLoadingProps {
  rowsCount?: number;
}

export const StatusTimelineLoading: React.FC<StatusTimelineLoadingProps> = ({ rowsCount = 3 }) => {
  const rows = Array.from({ length: rowsCount }, (_, i) => i);

  return (
    <VStack>
      <FlatList
        data={rows}
        keyExtractor={(item) => String(item)}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={() => <TimelineItemLoading />}
        showsVerticalScrollIndicator={false}
      />
    </VStack>
  );
};
